<script>
  import { getConfig } from "$lib/utils/config.js";
  /**
   * @type {{data: Record<string, any>[], cols?: string[], rowNumbers?: boolean, labelColumn?: boolean}}
   */
  const { data, cols, rowNumbers, labelColumn = true } = $props();

  const config = getConfig()();

  let colNames = $derived(
    cols
      ? cols
      : data.length > 0
        ? Object.keys(data[0]).filter((col) => !config.skipColumns.includes(col))
        : []
  );

  /** @type {("number" | "text")[]} */
  let colTypes = $derived(
    colNames.length > 0 && data.length > 0
      ? colNames.map((col) => {
          let checkRow = 0;
          // check if columns is number
          let checkVal = data[checkRow][col];
          // if value is NA, check next column
          while ((checkVal === "NA" || checkVal === "N/A") && checkRow < data.length - 1) {
            checkRow++;
            checkVal = data[checkRow][col];
          }
          if (typeof checkVal === "number") {
            return "number";
          } else if (checkRow === data.length - 1 && (checkVal === "NA" || checkVal === "N/A")) {
            // if we make it all the way to the end and the value is still NA, still treat it like a number
            return "number";
          }
          return "text";
        })
      : []
  );
</script>

<div class="table-wrapper" class:label-column={labelColumn}>
  <table class="tool-table">
    <thead>
      <tr class="row header">
        {#if rowNumbers}
          <th class="cell row-number"></th>
        {/if}
        {#each colNames as col, colIndex}
          {@const colType = colTypes[colIndex]}
          {@const colConfig = config.columns.get(col)}
          <th
            class="cell"
            class:type-text={colType === "text"}
            class:type-number={colType === "number"}
            >{@html colConfig
              ? colConfig.table_label
                ? colConfig.table_label
                : colConfig.column_label
              : col}</th
          >
        {/each}
      </tr>
    </thead>
    <tbody>
      {#each data as row, rowIndex}
        <tr class="row">
          {#each colNames as col, colIndex}
            {@const colType = colTypes[colIndex]}
            {@const formatter =
              colType === "number" ? config.columns.get(col).format : (val) => val}
            {#if rowNumbers && colIndex === 0}
              <td class="cell row-number">{rowIndex}</td>
            {/if}
            {#if colIndex === 0}
              <th
                class="cell first"
                class:type-text={colType === "text"}
                class:type-number={colType === "number"}>{formatter(row[col])}</th
              >
            {:else}
              <td
                class="cell"
                class:type-text={colType === "text"}
                class:type-number={colType === "number"}>{formatter(row[col])}</td
              >
            {/if}
          {/each}
        </tr>
      {/each}
    </tbody>
  </table>
</div>

<style>
  .table-wrapper {
    width: 100%;
    overflow-x: auto;
    scrollbar-color: var(--color-gray) var(--color-white);
  }
  .table-wrapper::-webkit-scrollbar-thumb {
    /* Foreground */
    background: var(--color-white);
  }
  .table-wrapper::-webkit-scrollbar-track {
    /* Background */
    background: var(--color-gray-shade-lighter);
  }
  .table-wrapper table.tool-table {
    margin: 0 auto;
    min-width: 100%;
    border-spacing: 0;
    font-size: var(--font-size-small);
  }

  /*** TABLE HEADER ***/
  .table-wrapper .row.header .cell {
    border-bottom: 2px solid var(--color-black);
    padding-bottom: var(--spacing-3);
    vertical-align: bottom;
    font-weight: 900;
  }

  /*** TABLE BODY ***/
  .cell {
    padding: var(--spacing-1);
    border-bottom: 2px solid var(--color-gray);
  }
  td.cell {
    color: var(--color-gray-shade-darkest);
    min-width: 8em;
  }
  .cell.type-text {
    text-align: left;
  }
  .cell.type-number {
    text-align: right;
  }
  .label-column .cell.first {
    min-width: 8rem;
  }
  .cell.row-number {
    text-align: left;
    min-width: 1em;
  }
</style>
